/**
 * Spec №14 (14.6, D-SH6) — first-run starter rows for the Needs-You home. The
 * server reconciles on read (a starter whose entity now exists comes back
 * `done: true`), so the home self-clears. Empty on workspaces without a shell.
 */
import { useQuery } from "@tanstack/react-query";
import { mcpClient } from "../../lib/mcp-client";

export interface StarterTask {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  deep_link: string;
  entity_slug: string;
  done: boolean;
}

export function useStarterTasks() {
  return useQuery({
    queryKey: ["starter-tasks"],
    staleTime: 30_000,
    queryFn: async () => {
      const r = await mcpClient.toolsCall<{ starters: StarterTask[] }>("list_starter_tasks");
      if (r.isError) return { starters: [] as StarterTask[] };
      return (r.structuredContent as { starters?: StarterTask[] }) ?? { starters: [] as StarterTask[] };
    },
  });
}
